module.exports = __webpack_public_path__ + "static/media/rhino.6820908a.gltf";